@import '../../styles/palette.scss';

.alert {
  background: #fff;
  border: 1px solid _palette(border-black-10);
  border-radius: 4px;
  margin-top: 20px;
  width: 100%;

  * {
    vertical-align: middle;
  }

  svg {
    color: _palette(input-border-outlined);
    margin: 15px;
  }
}
